import { NotificationInfoOutlineIcon } from '@tableau/icons/NotificationInfoOutlineIcon';
import { Tooltip, TooltipProps } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../../../codegen/Localize';

const tooltipProps: TooltipProps = {
    getContent: () => <span>{Messages.encryptionTooltip()}</span>
};

export const EncryptionTooltip = (): JSX.Element => {
    return (
    <Tooltip {...tooltipProps}>
      <NotificationInfoOutlineIcon
        size={16}
        style={{ minHeight: 15, position: 'relative', top: 3, left: 7 }} />
    </Tooltip>
  );
};
